module.exports = __webpack_public_path__ + "img/link.57639683.png";